const chevronDown = `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.7803 5.21967C13.0732 5.51256 13.0732 5.98744 12.7803 6.28033L8.53033 10.5303C8.23744 10.8232 7.76256 10.8232 7.46967 10.5303L3.21967 6.28033C2.92678 5.98744 2.92678 5.51256 3.21967 5.21967C3.51256 4.92678 3.98744 4.92678 4.28033 5.21967L8 8.93934L11.7197 5.21967C12.0126 4.92678 12.4874 4.92678 12.7803 5.21967Z"/></svg>`;
export {
  chevronDown as default
};
//# sourceMappingURL=chevronDown.mjs.map
